import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { MaterialGradeType } from "shared";

type MaterialPredictionDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.predictMaterial
>;

export const predictMaterial = async (
  id: string | undefined,
  payload: {
    materialGrade: MaterialGradeType;
    quantity: number | undefined;
  },
): Promise<MaterialPredictionDto | null> => {
  const { quantity } = payload;
  if (quantity === undefined) {
    return null;
  }

  if (!id) {
    return null;
  }

  const response = await api.quoteRequestLines.predictMaterial.mutation({
    params: { id },
    body: {
      quantity,
      materialGrade: payload.materialGrade,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
